import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { checkoutGraphql } from '@ztechapps/order.webui'
import { gql } from '@apollo/client'
import { purchaseOrderFragment as purchaseOrderFragmentCore } from '@ztechapps/purchase-order.common'

export const conversationFragment = `
 communication {
    _id
    email {
      _id
      to
      from
      timeStamp
      content
    }
  }
`

//we need to use the query from checkoutGraphql, so it will be sync with the CheckoutProvider
//This is related to the issue https://gitlab.com/ztech-apps/ztech-apps/-/issues/866
export const paymentFragment = checkoutGraphql.paymentFragment

export const vendorOrShipToFragment = `_id
    profile {
      _id
      name
      picture
      email
    }
    status
    company {
      _id
      name
      domain
    }
    phone
    address {
        _id
       street1
       street2
       city
       state
       zip
       fullAddress
       country
    }
    addresses {
        _id
       street1
       street2
       city
       state
       zip
       fullAddress
       country
       status
    }


    `

export const vendorQueries = buildGraphqlQuery('Vendor', vendorOrShipToFragment)

export const membersFragment = `members {
    _id
    profile {
      _id
      name
      email
      picture
    }
    company {
      _id
      name
    }
    phone
    remarks
    tags
    address {
      _id
      fullAddress
    }
  }`

export const queries = buildGraphqlQuery('PurchaseOrder', purchaseOrderFragmentCore, [
  'payments',
  'items',
  'relatedWorkOrders',
])

export const buildQuery = (field: string) =>
  buildGraphqlQuery('PurchaseOrder', `_id updatedAt status paymentStatus ${field}`)

export const amountQuery = `_id gross net taxAmount discount paymentBalance { _id balance totalPaid }`

export const updatePurchaseOrderProductInventoryQuery = gql`
  ${purchaseOrderFragmentCore}
  mutation updatePurchaseOrderProductInventory($input: PurchaseOrderUpdateProductInventoryArgs!) {
    updatePurchaseOrderProductInventory(input: $input) {
      ...purchaseOrderFragment
    }
  }
`

export const updatePurchaseOrderVendorCodeAndPriceQuery = gql`
  ${purchaseOrderFragmentCore}
  mutation updatePurchaseOrderVendorCodeAndPrice($input: UpdatePurchaseOrderVendorCodeAndPriceArgs!) {
    updatePurchaseOrderVendorCodeAndPrice(input: $input) {
      ...purchaseOrderFragment
    }
  }
`
